import _ from '../../core/utils'
const searchConfig = {
    el: _.select( '.header__search' ),
    header: _.select( '.header--main' ),
    form: _.select( '.header__search form' ),
    triggers: _.selectAll( '.header--main .search__trigger' ),
    triggerDesktop: _.select( '.header--main .block--search' ),
    breakpoint: 1024
}
export default searchConfig